"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAreaById = void 0;
const getAreaById = async (supabase, id) => {
    const { data, error } = await supabase
        .from("areas")
        .select("*")
        .eq("id", id)
        .single();
    if (error) {
        throw new Error(error.message);
    }
    return data;
};
exports.getAreaById = getAreaById;
